import { useSelector } from "../../../../hooks";
import { BusinessElementCard } from "./BusinessElementCard/BusinessElementCard";
import element1 from './../images/element1.jpg';
import element2 from './../images/element2.jpg';
import element3 from './../images/element3.jpg';
import element4 from './../images/element4.jpg';
import element5 from './../images/element5.jpg';
import element6 from './../images/element6.jpg';
import element7 from './../images/element7.jpg';

const images = [element1, element2, element3, element4, element5, element6, element7];

export const BusinessElements = () => {
    const business = useSelector(store => store.businesses.activeBusiness);

    if (!business)
        return <></>;

    return (
        <>
            { business.elements.map((element, index) =>
                <BusinessElementCard
                    key={ `element${index}` }
                    {...element}
                    image={ images[index] }
                />)
            }
        </>
    );
}